// Experience data for the portfolio
export const getExperienceData = experience => [
  {
    period: 'June 2023 - Present',
    title: 'Software Developer Engineer',
    company: 'MulticoreWare Pvt Ltd',
    location: 'Chennai, India',
    logo: '/MulticoreWare_Logo.jpg',
    description:
      'Performance engineering for AI accelerator hardware — profiling and benchmarking tensor operations, identifying bottlenecks across the software stack, and optimizing the code paths that drive throughput on next-generation AI silicon.',
    experience: experience,
    delay: 0.1,
  },
  {
    period: 'June 2022 - May 2023',
    title: 'Industrial Project Engineer',
    company: 'Lenovo Pvt Ltd',
    location: 'Pondicherry, India',
    logo: '/Lenovo_Global_Corporate_Logo.png',
    description:
      'Developed and maintained smart attendance system using face recognition technology and ESD tester with database integration. Worked on computer vision algorithms, biometric authentication systems, and real-time data processing for employee attendance tracking and ESD testing workflows.',
    experience: '1 year',
    delay: 0.2,
  },
];
